import { render, staticRenderFns } from "./MoneyType.vue?vue&type=template&id=70efa966&"
import script from "./MoneyType.vue?vue&type=script&lang=js&"
export * from "./MoneyType.vue?vue&type=script&lang=js&"
import style0 from "./MoneyType.vue?vue&type=style&index=0&id=70efa966&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports